export const valuesComparator = (firstValue, secondValue) => {
  if(firstValue < secondValue) {
    return -1;
  } else if(firstValue > secondValue) {
    return 1;
  } else {
    return 0;
  }
};



// WEBPACK FOOTER //
// ./src/utilities/comparators.js